import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';
import React from 'react';
import { Progress } from 'antd';
import classnames from 'classnames';
import { parseTradeline } from './CreditUsageTradeline.js';
import './CreditUsageTradeline.scss';
import {
  TradelineNotification,
  TradelineHeader,
  BureauBalanceAndRefreshButtonTableComponent,
} from '../Components/FactorTradelineBaseComponents.js';
import { isPremium, isFreeTrial, isPlus1B } from 'helpers/userHelper';
import { getSimplifiedDate } from 'helpers/dateHelper';
import { providerMapping } from 'customHelpersPath/factorMapping.helper';
import { canPurchase3BReport } from 'pages_CreditReportTU/creditReportTU3B.helper';
import { formatCurrency } from 'helpers/money.helper.js';
import { formatNumberNoDecimals } from 'helpers/number';

const { ALL, TRANS_UNION, EXPERIAN, EQUIFAX } = BUREAU_ENUMS;

const CreditUsageTradeLineComponent = props => {
  const {
    tradeline,
    userInfo,
    selectedBureau,
    profileContainer,
    creditReports,
  } = props;
  const creditProfileRefreshDate =
    profileContainer?.modules[0]?.additionalData?.creditProfileRefreshDate;
  const isPremiumUser = isPremium(userInfo) && !isFreeTrial(userInfo);
  const isDownloadAvailable = canPurchase3BReport({
    userInfo,
    creditReportRes: creditReports,
  });
  const is1B = isPlus1B(userInfo);
  const parsedTradeline = parseTradeline(tradeline, selectedBureau);
  const refreshDate = new Map([
    [ALL, getSimplifiedDate(new Date())],
    [TRANS_UNION, getSimplifiedDate(new Date())],
    [EQUIFAX, getSimplifiedDate(creditProfileRefreshDate?.equifax)],
    [EXPERIAN, getSimplifiedDate(creditProfileRefreshDate?.experian)],
  ]);
  const titleStyle = () => {
    return 'bold';
  };
  const progressBarPercent = () => {
    if (parsedTradeline?.duePercent >= 100) {
      return 100 / (parsedTradeline?.duePercent * 0.01);
    } else if (parsedTradeline?.duePercent >= 30) {
      return parsedTradeline?.duePercent;
    } else {
      return 0;
    }
  };
  const sucessProgressBarPercent = () => {
    if (parsedTradeline?.duePercent >= 100) {
      return 30 / (parsedTradeline?.duePercent * 0.01);
    } else if (parsedTradeline?.duePercent >= 30) {
      return 30;
    } else {
      return parsedTradeline?.duePercent;
    }
  };

  const creditLimit =
    parsedTradeline?.creditLimit === 0
      ? 'Not Available'
      : formatCurrency(parsedTradeline?.creditLimit);

  return (
    <FlexContainer
      className={
        'tradelineContainer bgWhite flex-column grayShadow16 margt16 padlr30 padb24 padt30 m-padt18 m-pad10 border-rad8px'
      }
    >
      <TradelineHeader
        titleStyle={titleStyle}
        title={parsedTradeline?.creditor}
        subtitle={'Balance: $' + parsedTradeline?.dueAmount?.toLocaleString()}
        basedOnBureauLabel={
          'Based on ' +
          providerMapping.get(selectedBureau) +
          ' report from ' +
          refreshDate.get(selectedBureau)
        }
        accountAmmount={
          parsedTradeline?.duePercent === Infinity
            ? ''
            : formatNumberNoDecimals(parsedTradeline?.duePercent) + '%'
        }
        statusLabel={'Limit: ' + creditLimit}
      />
      <FlexContainer
        className={classnames('margtb12 justify-between gap-24', {
          over85ProgressBarColors: parsedTradeline?.duePercent >= 85,
          over65ProgressBarColors: parsedTradeline?.duePercent >= 65,
          over30ProgressBarColors: parsedTradeline?.duePercent >= 30,
        })}
      >
        <Progress
          strokeWidth={5}
          showInfo={false}
          aria-label={'progress bar percentage'}
          percent={progressBarPercent()}
          success={{
            percent: sucessProgressBarPercent(),
          }}
        />
      </FlexContainer>
      <FlexContainer className={'flex-column'}>
        <BureauBalanceAndRefreshButtonTableComponent
          is1B={is1B}
          bureauBalance={parsedTradeline?.bureauBalance}
          isDownloadAvailable={isDownloadAvailable}
          isPremiumUser={isPremiumUser}
          selectedBureau={selectedBureau}
        />
      </FlexContainer>
      {!parsedTradeline?.dontShowMessage &&
        parsedTradeline?.creditLimit !== 0 && (
          <TradelineNotification
            parsedTradeline={parsedTradeline}
            showLegend={parsedTradeline?.duePercent > 30}
          />
        )}
    </FlexContainer>
  );
};

export { CreditUsageTradeLineComponent };
